import {
  makeEnvironmentProviders,
  type EnvironmentProviders,
} from '@angular/core';
import { provideNgxMask } from 'ngx-mask';

export function provideMyreFormsConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([provideNgxMask()]);
}
